import { RootState } from "@app/redux/root-reducer";

export const selectBeAnInvestorState = (store : RootState) => store.investorReducers.investor;
export const selectVerifyInvestorState = (store: RootState) =>
  store.investorReducers.verifyInvestor;
